import {AUTH, END_LOADING, LOGOUT, START_LOADING, UPDATE_USER_PROFILE} from '../actions/constants'

const authReducer = (state = {authData: null, isLoading: false}, action) => {
    switch (action.type) {
        case START_LOADING:
            return {...state, isLoading: true};
        case END_LOADING:
            return {...state, isLoading: false};
        case AUTH:
            localStorage.setItem('profile', JSON.stringify({...action?.data}))
            // console.log(action?.data)
            return {...state, authData: action?.data}

        case LOGOUT:
            localStorage.clear()
            return {...state, authData: null}

        case UPDATE_USER_PROFILE:
            localStorage.setItem('profile', JSON.stringify({...action?.data}))
            // console.log(action?.data)
            return {...state, authData: action?.data}

        default:
            return state
    }
}

export default authReducer